import React from "react";

export const DashboardLayout: React.FC = ({ children }) => {
  return <>{children}</>;
};
